import { AxiosError } from "axios";

export interface ErrorMap {
  tranKey?: string;
  tranParams?: Record<string, string | number>;
  message: string;
}

export const mapErrors = (error: Error | null): ErrorMap => {
  if (error === null) {
    return { message: "" };
  }

  if (error instanceof AxiosError && error.response) {
    const data = error.response.data;

    if (data?.tranKey) {
      return {
        tranKey: "errors." + data.tranKey,
        tranParams: data.tranParams,
        message: data.message,
      };
    }

    if (data?.message) {
      return { message: data.message };
    }

    if (typeof data === "string" && data.trim()) {
      return { message: data };
    }
  }

  // AxiosError with no response = the API is unreachable (server down,
  // connection refused, timeout, network/CORS). Show a friendly localized
  // message instead of axios's raw "Network Error".
  if (
    error instanceof AxiosError &&
    !error.response &&
    (error.code === "ERR_NETWORK" ||
      error.code === "ECONNABORTED" ||
      error.message === "Network Error")
  ) {
    return {
      tranKey: "errors.service_unavailable",
      message: "Sunucuya ulaşılamıyor, kısa süre içinde tekrar deneyin.",
    };
  }

  if (error instanceof Error && error.message) {
    return { message: error.message };
  }

  return { message: "Something went wrong" };
};
